import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ query, onClearSearch, onRefineSearch }) => {
  const suggestions = [
    "Try searching for a different name",
    "Check your spelling",
    "Use a shorter search term",
    "Try searching by first name only"
  ];

  return (
    <div className="text-center py-12 px-4">
      <div className="max-w-md mx-auto">
        {/* Icon */}
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-6">
          <Icon name="Search" size={32} className="text-muted-foreground" />
        </div>

        {/* Heading */}
        <h2 className="text-xl font-semibold text-foreground mb-2">
          No results found
        </h2>

        {/* Description */}
        <p className="text-muted-foreground mb-6">
          {query ? (
            <>
              We couldn't find anyone matching "<span className="font-medium">{query}</span>". 
              Try adjusting your search.
            </>
          ) : (
            "Start typing to search for people on Aether."
          )}
        </p>

        {/* Suggestions */}
        {query && (
          <div className="bg-surface border border-border rounded-lg p-4 mb-6">
            <h3 className="font-medium text-foreground mb-3">
              Search suggestions:
            </h3>
            <ul className="text-left space-y-2">
              {suggestions?.map((suggestion, index) => (
                <li key={index} className="flex items-start text-sm text-muted-foreground">
                  <Icon name="Lightbulb" size={14} className="mr-2 mt-0.5 flex-shrink-0" />
                  {suggestion}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {query && (
            <Button
              variant="outline"
              onClick={onClearSearch}
              iconName="X"
              iconPosition="left"
              iconSize={16}
            >
              Clear Search
            </Button>
          )}
          
          <Button
            variant="default"
            onClick={onRefineSearch}
            iconName="Search"
            iconPosition="left"
            iconSize={16}
          >
            Try Different Search
          </Button>
        </div>

        {/* Popular Searches */}
        <div className="mt-8 pt-6 border-t border-border">
          <h3 className="font-medium text-foreground mb-3">
            Popular searches:
          </h3>
          <div className="flex flex-wrap gap-2 justify-center">
            {['Sarah', 'Michael', 'Emily', 'David', 'Jessica']?.map((name) => (
              <button
                key={name}
                onClick={() => onRefineSearch?.(name)}
                className="px-3 py-1 bg-surface hover:bg-muted border border-border rounded-full text-sm text-foreground transition-colors duration-150"
              >
                {name}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;